module.exports = __webpack_public_path__ + "7397ac760146491e5bbc116113979f30.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_4_0.ttf
// module id = 542
// module chunks = 0